// extracted by mini-css-extract-plugin
export default {"video":"video__3azbk","videoLoading":"videoLoading__29K7c","main":"main__Yqcda","loading":"loading__22VLj","iconWrapper":"iconWrapper__I2NSy","sentence":"sentence__7sAoc"};